export default class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message =
      message || 'Autenticação obrigatória. Favor realizar login novamente.';
    this.errorCode = errorCode || 401;
  }
}
